module.exports = __webpack_public_path__ + "img/nb-5.a9189fd1.png";